"use client";

import React from "react";
import { Menu, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { CartIcon } from "@/components/shop/CartIcon";
import { cn } from "@/lib/utils";
function DesktopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="238736" className="flex gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-9 w-24 animate-pulse rounded-md bg-muted/20" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-2">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className={cn(navigationMenuTriggerStyle(), "bg-transparent text-foreground font-default text-lg tracking-wide hover:bg-transparent hover:text-primary focus:bg-transparent focus:text-primary data-[active=true]:text-primary data-[state=open]:bg-transparent transition-colors duration-300")}>
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="mt-8 flex flex-col gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-10 w-full animate-pulse rounded-md bg-muted/20" />)}
      </div>;
  }
  return <div className="mt-8 flex flex-col gap-4">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-xl font-default font-medium text-foreground transition-colors hover:text-primary">
          {item.label}
        </Link>)}
    </div>;
}
export default function TravelHeader() {
  return <section id="menu" className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur-sm supports-[backdrop-filter]:bg-background/80">
      <div className="container mx-auto grid h-20 grid-cols-12 items-center gap-4 px-4 md:px-6 lg:px-8">
        {}
        <div className="col-span-6 flex items-center md:col-span-3 lg:col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648136/img/logorettangolare.png" alt="SacroPan" className="object-contain brightness-200 !w-[1000.663px] !h-[77px]" />
          </Link>
        </div>

        {}
        <div className="hidden md:col-span-6 md:flex md:justify-center lg:col-span-8">
          <MenuProvider menu_id="16">
            <DesktopNav />
          </MenuProvider>
        </div>

        {}
        <div className="col-span-6 flex items-center justify-end gap-2 md:col-span-3 lg:col-span-2 sm:gap-4">
          <CartIcon variant="ghost" size="icon" className="text-foreground hover:bg-transparent hover:text-primary transition-colors" iconSize="size-5" />
          
          <Button className="hidden rounded-none bg-primary px-6 font-default font-medium text-primary-foreground shadow-none hover:bg-primary/80 sm:inline-flex transition-all duration-300">
            Esplora ora
          </Button>

          {}
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-transparent hover:text-primary">
                <Menu className="size-6" />
                <span className="sr-only">Apri menù</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] border-l border-border bg-background/98 backdrop-blur-xl sm:w-[400px]">
              <SheetTitle className="text-left font-default text-2xl text-foreground border-b border-border pb-4">
                Navigazione
              </SheetTitle>
              <MenuProvider menu_id="16">
                <MobileNav />
              </MenuProvider>
              <div className="mt-auto pt-8">
                <Button className="w-full rounded-none bg-primary py-6 font-default text-lg font-medium text-primary-foreground shadow-none hover:bg-primary/80">
                  Esplora ora
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </section>;
}